export default "__VITE_ASSET__b7c45431__"